export default __webpack_public_path__ + "static/media/event1.ec80152d.jpg";